import moment from 'moment';

import React, { PropTypes, Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  NitroHeading,
  NitroDivider,
  NitroButton,
  NitroButtonGroup,
  NitroGrids,
  NitroGrid,
  NitroDrawer,
  NitroPanel,
  NitroContentNotAvailable,
  NitroIcon,
  NitroText
} from 'nitro-components';

import { media } from 'style-utils';
import styled from 'styled-components';

import ApiActions from '../../action/ActionFactory';
import * as globalActions from '../../action/CommonActions';
// Update to default role when applying with country change
import { changeCurrentRole } from '../../auth/actions';
import {
  getCurrentRole,
  getFormatedRoles
} from '../../components/common/Profile/selector';
import { updateCurrentRole } from '../../components/common/Profile/utils';

import {
  FilterGroup,
  CostcenterFilter,
  CountryFilter
} from '../../components/filter';
import FilterMobileComponent from '../../components/common/FilterMobileComponent';

import Container from '../../components/layouts/Container';
import Header from '../../components/layouts/Header';
import Page from '../../components/layouts/Page';

import * as routes from '../../routes/const';
import { pushGAAction } from '../../utils/gtm';
import Breakpoint from '../../utils/breakpoints';

import { NotificationMessage } from '../common/GlobalNotification';

import * as actions from './actions';
import {
  getData,
  exportData,
  isDataEmpty,
  exportDocument,
  getActiveInsight
} from './helpers';
import { getInsightsCCAndCountry, getRestrictionFilter } from './selector';

import InsightMetric from './components/InsightMetric';
import InsightChart from './components/InsightChart';
import ExportDrawer from './components/ExportDrawer';

import { noDataHint, DEFAULT_GRAPH_DATA_API } from './const';

const InsightGrid = styled.div`
  min-width: 100%;
  min-width: calc(100% + 18px);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0 -9px;

  .grid-item {
    ${media.mobile`
      flex-basis: 50%;
      max-width: 50%;
      padding: 0 5px 18px 5px;
      position: relative;
    `};
  }
`;

const GridContainer = styled.div`
  width: 100%;
  height: 100%;
  background: ${props => props.theme.color.white};
`;

const InsightsDetailDescription = styled.p`
  max-height: 9rem;
`;

const Tile = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 24px;
  background: ${props => props.theme.color.white};
  box-shadow: ${props => props.theme.boxShadow[1]};
  border-radius: 2px;
  overflow: hidden;
  margin-bottom: 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: all 0.2s ease;
  z-index: 2;

  &:hover {
    transform: translate(0, -6px);
    box-shadow: 0 12px 20px 0 rgba(0, 0, 0, 0.35);

    ${media.mobileTablet`
        transform: none;
        box-shadow: ${props => props.theme.boxShadow[1]};
      `};
  }
  ${media.mobile`
    z-index: 2;
    padding: 30px 24px;

     > p {
      display: none;
     }
  `} header {
    margin-top: 10px;
  }
`;

const NotificationBadge = styled.div`
  position: absolute;
  right: 2px;
  top: -6px;
  min-width: 26px;
  height: 25px;
  background: #ff632d;
  z-index: 3;
  padding: 2px 10px;
  color: ${props => props.theme.color.white};
  text-align: center;
  border-radius: 20px 10px 0px 20px;

  ${media.mobile`
    padding: 2px 8px;
    height: 25px;
    right: 0px;
  `};
`;

const NotificationBadgeBorder = styled.span`
  right: 2px;
  top: 19px;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: rgba(213, 129, 72, 0);
  border-top-color: #b83f16;
  border-width: 20px;
  margin-left: -15px;
  z-index: 1;
  ${media.mobile`
    top: 18px;
    right:0px;
  `};
`;

const HeaderRightContainer = styled.div`
  float: right;
  ${media.mobile`
    float: none;
  `} >a {
    margin-left: 30px;
    text-decoration: none;
  }
`;

const InsightDrawerNotification = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const InsightDrawerContainer = styled.div`
  padding: 56px 0 30px 0;
  display: block;
  height: 100%;

  ${media.mobile`
    padding: 32px 15px;
  `};
`;

const InsightDrawerContent = styled.div`
  display: block;
  display: flex;
`;

const InsightDrawerChart = styled.div`
  flex: 1 0 60%;
  padding: 0 35px 16px 16px;
  height: 300px;
  @include clearfix;

  .highcharts-container {
    height: 300px !important;
    ${media.mobile`
      height: 250px !important;
    `};
  }

  ${media.mobile`
    width: 100%;
    padding: 0;
    display: none;
  `};
`;

const InsightDrawerDetails = styled.div`
  flex: 0 1 40%;
  padding: 18px 0 0px 35px;
  display: flex;

  flex-direction: column;
  justify-content: space-between;

  ${media.mobile`
    width: 100%;
    padding: 0 24px;
  `};
`;

class Insights extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPanel: false,
      id: '',
      title: '',
      description: '',
      exportOpen: false,
      refreshTileContent: false,
      url: '',
      isYFReport: false,
      reportId: '' // different to "id". If slideup intial preview report id is different to the actual report id within the tree hireachy.This prop is used to store the grand children report id.
      /* example JSON  DONT REMOVE THE COMMENTS --
        {
            "id":"AAA",
            "url":"api/insight/getTileData",
            "children":[
               {
                  "id":"BBB",  -------------------------------    id in the state is used to hold this id
                  "displaytype":"chartUtilisation",
                  "children":[{
                      "id":"CCC",   ----------------------------    reportId in the state is used to hold this id
                       "displaytype":"scatterPlotChart",
                       }
                  ],
               }
            ],
            "displaytype":"tileUtilisation"
        }
      */
    };
    this.deleteNotification = this.deleteNotification.bind(this);
    this.viewReport = this.viewReport.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.refreshFlag &&
      prevProps.refreshFlag !== this.props.refreshFlag
    ) {
      this.setState(
        {
          refreshTileContent: true // Flag if tile content needs to be updated..Used after global notification delete or insight notification delete
        },
        this.resetRefreshFlag
      );
    }
  }

  resetRefreshFlag = () => {
    this.setState({ refreshTileContent: false });
    this.props.actions.resetRefreshFlag();
  };

  closePanel = () => {
    this.setState({
      showPanel: false,
      isYFReport: false
    });
    this.cleanStaleData();
  };

  openPanel = (children, tileTitle) => {
    pushGAAction('INSIGHT', `TileClick::${tileTitle}`);

    this.cleanStaleData();
    if (children.length) {
      const childNode = children[0];
      const { url } = childNode;
      let reportId = childNode.id;
      let isYFReport = false;
      const routeUrl = childNode.route !== undefined ? childNode.route : '';
      const displayType = childNode.displaytype;
      const yfregex = new RegExp('YF|Yellowfin', 'gi');

      // If grandchild present set the reportid to the grandchild id , if not reportid points to the child node id
      if (childNode.children && childNode.children.length) {
        const grandChildNode = childNode.children[0];
        reportId = grandChildNode.id;
        isYFReport = yfregex.test(grandChildNode.displaytype);
      }

      yfregex.lastIndex = 0;
      if (yfregex.test(childNode.displaytype)) {
        return this.viewData(reportId, 'YF');
      }

      if (displayType === 'menuDefault') {
        return this.viewData(reportId, '', routeUrl);
      }

      this.setState(
        {
          showPanel: true,
          loading: true,
          id: children[0].id,
          title: children[0].title,
          description: children[0].description,
          url,
          reportId,
          isYFReport
        },
        this.getGraphData
      );
    } else {
      this.setState({
        showPanel: false,
        loading: false
      });
    }
  };

  openExportPanel = () => {
    this.setState({
      showPanel: false,
      exportOpen: true
    });
  };
  closeExportPanel = () => {
    this.setState({
      exportOpen: false
    });
  };

  // Node.js style error first callback function
  // for getData
  getDataCallback = async (error, data, isReset) => {
    // set local error state and pass
    // to child component for error message rendering
    this.setState({
      error: error || null
    });

    if (data.data && /chartsummary/gi.test(data.data.ChartType)) {
      const metadata = await this.getMetadata(this.state.id);
      this.setState({
        metadata: metadata[0]
      });
    }

    pushGAAction('INSIGHT', `Insight::BottomDrawerOpen::${data.title}`);

    this.props.actions.setInsightData(data);
  };

  getGraphData = async () => {
    const filter = await this.getFilterData(this.state.id);
    getData(
      this.getOptions(filter),
      this.getDataCallback,
      null,
      this.props.actions
    );
  };

  viewData = (id, type, routeUrl) => {
    // clear the redux store with stale data of slidup panel -- anyways this data is again set using the report view getGraphData API
    // this.props.actions.localActions.setInsightData({ data: {} });
    if (routeUrl !== undefined) {
      // good now lets check if it has id
      const tableDetailsRegEx = new RegExp(':id');
      this.props.actions.setReportParams({});
      this.props.actions.setInsightData({ data: {} });

      const viewRoute = tableDetailsRegEx.test(routeUrl)
        ? `${routes.TABLEDETAIL}`.replace(':id', id)
        : routeUrl;
      return this.context.router.push(viewRoute);
    }
    this.props.actions.setReportParams({});
    this.props.actions.setInsightData({ data: {} });

    let route = `${routes.REPORTS_VIEW}/${id}`;
    if ((type && type === 'YF') || this.state.isYFReport) {
      route = `${routes.REPORT_YELLOWFIN}`.replace(':id', id);
    }

    this.context.router.push(route);
  };

  cleanStaleData = () => {
    // Clear any stale data.
    this.props.actions.setInsightData({
      data: {},
      title: ''
    });
    // this.resetRefreshFlag();
  };

  getFilterData(id) {
    return this.props.apiActions
      .get({
        resource: 'INSIGHTS_GRAPH_FILTER',
        data: {
          id
        }
      })
      .then(data => data.filters);
  }

  getMetadata(id) {
    return this.props.apiActions
      .get({
        resource: 'CONTENT',
        id
      })
      .then(data => data);
  }

  getOptions = filters => {
    const { costcenter, country, restrictions } = this.props;

    const activeInsight = getActiveInsight(this.props.tiles, this.state.id);
    const url = activeInsight ? activeInsight.url : DEFAULT_GRAPH_DATA_API;

    const options = {
      id: this.state.id,
      url,
      source: {
        costcenter,
        country,
        restrictions
      }
    };

    if (filters) {
      // NITRO-1119 - setting up time frame in preview graph
      const dateFilter = filters.filter(filterItem =>
        /(time|date)/gi.test(filterItem.filterType)
      )[0];

      if (dateFilter) {
        const datetype = {
          y: 'year',
          m: 'months',
          d: 'day'
        };

        const filterValue = dateFilter.filters[0].value;
        const value = Math.abs(filterValue);
        const dtType = datetype[dateFilter.filters[0].datetype];

        let startDate;
        let endDate;

        if (filterValue < 0) {
          startDate = moment()
            .startOf('month')
            .subtract(value, dtType)
            .format('D MMM YY');
          endDate = moment()
            .endOf('month')
            .format('D MMM YY');
        } else {
          const date = new Date();
          const now = new Date(date.getFullYear(), date.getMonth(), 1);
          endDate = moment(now)
            .add(value, dtType)
            .subtract(1, 'days')
            .format('D MMM YY');

          startDate = moment(now).format('D MMM YY');
        }

        options.filter = {
          startDate,
          endDate
        };
      }
    }
    return options;
  };

  exportCSV = async () => {
    const filter = await this.getFilterData(this.state.id);
    const options = this.getOptions(filter);
    exportData(options);
  };

  exportChart = options => {
    this.refs.insightsChart.export(options);
  };

  exportDocument = (svg, options) => {
    const chartOptions = {
      //  width: 0,
      scale: 1,
      type: options.type
    };
    exportDocument(svg, chartOptions);
  };

  setFilter = filters => {
    // update role here
    const country = filters[0];
    const costcenter = filters[1];
    this.props.setGlobalCountryCostCenter({ country, costcenter });
    if (this.props.role.country !== country.value) {
      // update role when country is changed in filter
      updateCurrentRole(
        this.props.roles,
        [],
        country.value,
        'ROLEDRAWERCHANGE',
        newRole => {
          this.props.setGlobalDynamicFilter([]);
          this.props.changeCurrentRole(newRole);
          this.context.router.push(routes.INSIGHTS);
        }
      );
    }
  };

  deleteNotification = () => {
    this.getGraphData();
    this.setState({ refreshTileContent: true });
    this.resetRefreshFlag();
  };

  viewReport = reportParam => {
    this.props.actions.setReportParams(reportParam);
    this.context.router.push({
      pathname: `${routes.REPORTS_VIEW}/${reportParam.ContentId}`
    });
  };

  render() {
    const { country, costcenter, restrictions } = this.props;
    const filters = [
      {
        title: 'Country',
        label: country.label,
        value: country.value,
        component: CountryFilter
      },
      {
        title: 'Cost Centre',
        component: CostcenterFilter,
        value: costcenter.value,
        label: costcenter.label
      }
    ];

    let source = (
      <FilterGroup
        width="85%"
        action={this.setFilter}
        title="Source"
        icon="source"
        filters={filters}
        align="right"
      />
    );

    if (!country.value) {
      source = null;
    }

    let tiles = this.props.tiles.map((item, index) => (
      <NitroGrid
        grid={4}
        key={index}
        transition
        transitionDuration={800}
        transitionDelay={100 * index}>
          <GridContainer
          id={`grid_container_${item.id}`}
          onClick={() => this.openPanel(item.children, item.title)}>
              <InsightMetric
            id={item.id}
            source={{ country, costcenter, restrictions }}
            type={item.displaytype}
            title={item.title}
            timeStamp={item.timeStamp}
            description={item.description}
            refreshContent={this.state.refreshTileContent}
            url={item.url}
            route={item.route}
          />
        </GridContainer>
      </NitroGrid>
    ));

    if (!country.value || !costcenter.value) {
      tiles = (
        <NitroPanel>
          <NitroContentNotAvailable content={noDataHint} />
        </NitroPanel>
      );
    }

    const hasNotifications =
      this.props.notificationData && this.props.notificationData.length > 0;

    return (
      <Page header>
        <section>
          <ExportDrawer
            open={this.state.exportOpen}
            close={this.closeExportPanel}
            exportCSV={this.exportCSV}
            exportChart={this.exportChart}
          />
          <Header>
              <Breakpoint name="desktop">
              <NitroHeading header inline noMargin label="Dashboard" />
              {source}
            </Breakpoint>
            <Breakpoint name="mobileTablet">
                <FilterMobileComponent
                onClickSource={this.setFilter}
                source={filters}
              />
            </Breakpoint>
            </Header>

            <NitroGrids transitionIn>{tiles}</NitroGrids>

            <NitroDrawer
            isOpen={this.state.showPanel}
            close={this.closePanel}
            height={hasNotifications ? 575 : 460}
            noPadding
            slideUp
            variant="white"
            iconVariant="base3">
              <Container>
              <InsightDrawerContainer>
                  {hasNotifications && (
                  <div>
                    <NitroHeading
                      header
                      inline
                      noMargin
                      size="3"
                      variant="base3"
                      label="Here’s what happened while you were away"
                    />
                    <HeaderRightContainer>
                        <Link to={routes.NOTIFICATION_SETTINGS}>
                        <NitroIcon
                            name="settings"
                            size="16"
                            right={6}
                            variant="base3"
                        />
                        <NitroText variant="base3" size="4" bold>
                          bold>SETTINGS
                          </NitroText>
                      </Link>
                        {this.props.notificationData &&
                        this.props.notificationData.length > 3 && (
                          <Link
                            onClick={() => this.viewData(this.state.reportId)}>
                              <NitroText variant="notification" size="4" bold>
                              {`SEE ALL ${this.props.notificationData.length}`}
                            </NitroText>
                          </Link>
                        )}
                      </HeaderRightContainer>{' '}
                  </div>
                )}
                <InsightDrawerNotification>
                    {this.props.notificationData &&
                    this.props.notificationData.length > 0 &&
                    this.props.notificationData.map((item, index) => {
                      if (index >= 4) return null;
                      return (
                        <NotificationMessage
                          categoryName={item.CategoryName}
                          description={item.Description}
                          timeStamp={item.DaysToolText}
                          displayDeleteFullWidth
                          condensed
                          minVersion
                          keys={item.NotificationKeys}
                          key={index}
                          onDelete={this.deleteNotification}
                          reportParam={item.ReportParameters}
                          onClick={() => this.viewReport(item.ReportParameters)}
                        />
                      );
                    })}
                  </InsightDrawerNotification>
                  <InsightDrawerContent>
                  <InsightDrawerChart>
                      <InsightChart
                      ref="insightsChart"
                      // pass local error state
                      // to child component for error message display
                      error={this.state.error}
                      data={this.props.data}
                      metadata={this.state.metadata}
                      exportDocument={this.exportDocument}
                      graphLoading={this.props.fetchingDetailData}
                      insideDrawer
                    />
                    </InsightDrawerChart>

                    <InsightDrawerDetails>
                    <section>
                      <NitroHeading
                            label={this.state.title}
                            variant="secondary"
                      />
                      <InsightsDetailDescription>
                          {this.state.description}
                        </InsightsDetailDescription>
                    </section>
                          <section>
                      <NitroDivider noTopPad />

                      <NitroButtonGroup align="right" layout="horizontal">
                          {isDataEmpty(this.props.data) ? null : (
                          <NitroButton
                              size="compact"
                              label="Export"
                              icon="export"
                              action={this.openExportPanel}
                          />
                        )}
                        <NitroButton
                            size="compact"
                            label="View data"
                            variant="secondary"
                            action={() => this.viewData(this.state.reportId)}
                        />
                        </NitroButtonGroup>
                    </section>
                  </InsightDrawerDetails>
                </InsightDrawerContent>
                </InsightDrawerContainer>
            </Container>
          </NitroDrawer>
        </section>
      </Page>
    );
  }
}

const mapStateToProps = state => {
  const { costcenter, country } = getInsightsCCAndCountry(state);
  const { restrictions } = getRestrictionFilter(state);

  const insightTiles = state.auth.config.tiles;

  return {
    country,
    costcenter,
    data: state.insights.data,
    fetchingDetailData: state.insights.fetchingGraphData,
    notificationData: state.insights.notification,
    restrictions,
    refreshFlag: state.insights.refreshContentNotificationUpdate.update,
    role: getCurrentRole(state),
    roles: getFormatedRoles(state),
    tiles: insightTiles
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
  apiActions: bindActionCreators(ApiActions, dispatch),
  changeCurrentRole: bindActionCreators(changeCurrentRole, dispatch),
  setGlobalCountryCostCenter: bindActionCreators(
    globalActions.setGlobalCountryCostCenter,
    dispatch
  ),
  setGlobalDynamicFilter: bindActionCreators(
    globalActions.setGlobalDynamicFilter,
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(Insights);

Insights.propTypes = {
  data: PropTypes.shape({}),
  notificationData: PropTypes.array,
  actions: PropTypes.shape({}).isRequired,
  tiles: PropTypes.array,
  country: PropTypes.shape({}),
  costcenter: PropTypes.shape({}),
  restrictions: PropTypes.array,
  refreshFlag: PropTypes.bool,
  globalActions: PropTypes.shape({}),
  fetchingDetailData: PropTypes.bool
};

Insights.contextTypes = {
  router: PropTypes.shape({})
};



// WEBPACK FOOTER //
// ./src/features/insights/Insights.js